import { glListenersMixin } from '~/lib/utils/vue3compat/gl_listeners_mixin';
import RepoDropdown from './repo_dropdown.vue?vue3';
import RevisionDropdown from './revision_dropdown.vue?vue3';
export default {
    name: 'RevisionCard',
    components: {
        RepoDropdown,
        RevisionDropdown
    },
    mixins: [
        glListenersMixin
    ],
    props: {
        refsProjectPath: {
            type: String,
            required: true
        },
        revisionText: {
            type: String,
            required: true
        },
        paramsName: {
            type: String,
            required: true
        },
        paramsBranch: {
            type: String,
            required: false,
            default: null
        },
        selectedProject: {
            type: Object,
            required: true
        },
        disableRepoDropdown: {
            type: Boolean,
            required: false,
            default: false
        }
    }
};
